import { Container } from "../../App.styles";
import { CalloutContainer } from "./Callout.style";

export default function Callout(props) {
    const { children, ...rest } = props;

    return (
        <Container>
            <CalloutContainer {...rest}>
                {children}
            </CalloutContainer>
        </Container>
    )
}